import React, { useState, useEffect, useRef } from "react";
import Header from "../../Header";
import RequestMainInformation from "../../RequestMainInformation/RequestMainInformation";
import "../../pages/SubmitButton.css";
import "./Request.css";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { enHSInstance } from "../../../App";
import toast from "react-hot-toast";
import CriticalInfoBlock from "../../CriticalInfoBlock/CriticalInfoBlock";
import RequestMainBossInformation from "../../RequestMainInformation/RequestMainBossInformation";
import CreditInfo from "../../CreditInfo/CreditInfo";
import ConnectionError from "../../ConnectionError/ConnectionError";

function Request() {
  const location = useLocation();
  const navigate = useNavigate();
  const request = location?.state?.request;

  localStorage.setItem("theme", "light");

  const theme = localStorage.getItem("theme");
  document.documentElement.dataset.theme = theme;
  const [selectedSchema, setSelectedSchema] = useState("Схема В");
  const [commentary, setCommentary] = useState("");
  const [creditData, setCreditData] = useState();
  const [creditError, setCreditError] = useState(null);
  const [itsBoss, setItsBoss] = useState();
  const actionInProgress = useRef(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function confirmReq() {
    if (actionInProgress.current || !request?.order_uid) return;
    if (selectedSchema === "") {
      toast.error("Выберите схему");
      return;
    }

    actionInProgress.current = true;
    setIsSubmitting(true);
    try {
      const response = await enHSInstance.post(
        `https://api-erkon.tech/mobile/hs/ObmenMP/AcceptOrder`,
        {
          orderUID: request.order_uid,
          ...(request.requiredScheme && { selectedSchema: selectedSchema }),
          nomenclature: request.nomenclature,
          commentary: commentary,
        },
        {
          headers: {
            token: localStorage.getItem("tokenMANAGER"),
          },
        },
      );

      if (response.status === 200) {
        navigate(-1);
      } else {
        toast.error("Не удалось одобрить заявку. Обновите список заявок.");
      }
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.removeItem("tokenMANAGER");
        window.location.replace("/login");
      } else {
        toast.error("Не удалось одобрить заявку. Обновите список заявок.");
      }
    } finally {
      actionInProgress.current = false;
      setIsSubmitting(false);
    }
  }

  async function cancelReq() {
    if (actionInProgress.current || !request?.order_uid) return;
    actionInProgress.current = true;
    setIsSubmitting(true);

    try {
      const response = await enHSInstance.post(
        `https://api-erkon.tech/mobile/hs/ObmenMP/deletePWA`,
        { orderUID: request.order_uid },
        {
          headers: {
            token: localStorage.getItem("tokenMANAGER"),
          },
        },
      );

      if (response.status === 200) {
        navigate(-1);
      } else {
        toast.error("Не удалось отменить заявку. Обновите список заявок.");
      }
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.removeItem("tokenMANAGER");
        window.location.replace("/login");
      } else {
        toast.error("Не удалось отменить заявку. Обновите список заявок.");
      }
    } finally {
      actionInProgress.current = false;
      setIsSubmitting(false);
    }
  }

  async function getCredit() {
    if (!request) return;
    try {
      const response = await enHSInstance.post(
        `https://api-erkon.tech/mobile/hs/ObmenMP/debitInfo/`,
        {
          token: localStorage.getItem("tokenMANAGER"),
          orderUID: request.order_uid,
        },
      );
      const data = response.data?.[0];
      if (response.status === 200 && data) {
        setCreditData(data);
        setCreditError(null);
      } else {
        setCreditError(response.status || "invalid");
      }
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.removeItem("tokenMANAGER");
        window.location.replace("/login");
      } else {
        setCreditError(error.response?.status || "network");
      }
    }
  }

  useEffect(() => {
    getCredit();
  }, []);

  if (!request) {
    return <Navigate to="/requests" replace />;
  }

  return (
    <div
      className={
        creditData ? "request-page request-page--with-actions" : "request-page"
      }
    >
      <Header backRedirect={-1} headerTitle={request.nomenclature} />
      {!creditData ? (
        creditError ? (
          <ConnectionError
            status={creditError}
            onRetry={() => {
              setCreditError(null);
              getCredit();
            }}
          />
        ) : (
          <span className="loadingHeader">Загрузка...</span>
        )
      ) : (
        <React.Fragment>
          {creditData?.itsBoss ? (
            <div className="block-reasons">
              {creditData?.blockReasons.map((reason, index) => (
                <CriticalInfoBlock key={index} text={reason} />
              ))}
            </div>
          ) : (
            <>
              <CreditInfo creditData={creditData} />
              <div className="nomenclatureAndCapacity">
                {request.requiredScheme && (
                  <>
                    <span class="titleRequestMenu">Схема</span>
                    <div className="coneDraftButtons">
                      <button
                        className={
                          selectedSchema === "Схема В"
                            ? "coneDraftBtn pressed"
                            : "coneDraftBtn"
                        }
                        onClick={() => setSelectedSchema("Схема В")}
                      >
                        Схема В
                      </button>
                      <button
                        onClick={() => setSelectedSchema("Схема Г")}
                        className={
                          selectedSchema === "Схема Г"
                            ? "coneDraftBtn pressed"
                            : "coneDraftBtn"
                        }
                      >
                        Схема Г
                      </button>
                    </div>
                  </>
                )}
                <span className="titleRequestMenu">Комментарии</span>
                {request?.commentDriver && (
                  <input
                    type="text"
                    title="Комментарий водителю"
                    value={request?.commentDriver}
                    disabled
                    style={{
                      height: "60px",
                      padding: "0px 16px",
                      gap: "16px",
                      alignSelf: "stretch",
                      alignItems: "center",
                      borderRadius: "8px",
                      backgroundClip: "var(--white-gray)",
                      color: "var(--txt-color)",
                      textOverflow: "ellipsis",
                      fontSize: "16px",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "24px",
                      fontFamily: "Inter",
                      fontFeatureSettings: '"case" on',
                    }}
                  />
                )}

                <input
                  type="text"
                  placeholder="Комментарий логисту"
                  value={commentary}
                  onChange={(e) => setCommentary(e.target.value)}
                  style={{
                    height: "60px",
                    padding: "0px 16px",
                    gap: "16px",
                    alignSelf: "stretch",
                    alignItems: "center",
                    borderRadius: "8px",
                    backgroundClip: "var(--white-gray)",
                    color: "var(--txt-color)",
                    textOverflow: "ellipsis",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "24px",
                    fontFamily: "Inter",
                    fontFeatureSettings: '"case" on',
                  }}
                ></input>
              </div>
            </>
          )}

          {creditData?.itsBoss ? (
            <RequestMainBossInformation
              request={request}
              creditData={creditData}
            />
          ) : (
            <RequestMainInformation request={request} />
          )}
          <div className="footerCreateRequest">
            <div className="footerSubmitButton">
              <button
                className="submitButton active"
                onClick={() => confirmReq()}
                disabled={isSubmitting}
              >
                Одобрить заявку
              </button>
              <button
                className="submitButton"
                onClick={() => cancelReq()}
                disabled={isSubmitting}
              >
                Отменить заявку
              </button>
            </div>
          </div>
        </React.Fragment>
      )}
    </div>
  );
}

export default Request;
